import classNames from 'classnames';

import { Picture, type PictureProps } from '@farmersdog/corgi-x';

import styles from './Background.module.scss';

export function Background({ className, ...props }: PictureProps) {
  return (
    <Picture className={classNames(styles.background, className)} {...props} />
  );
}
